
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {AdviserModel} from '@/models/adviserModel';
  import {advisersModule, advisersState, challengeModule} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ChallengerDetailAdviser from '@/components/Challenges/tabs/advisers/ChallengerDetailAdviser.vue';

  @Component({
    components: {
      ChallengerDetailAdviser,
    }
  })
  export default class ChallengerAdvisers extends Vue {

    @advisersModule.Getter('advisers') advisers!: AdviserModel[];
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel | null;

    formatTitle(advisers: number): string {
      if (advisers > 1) {
        return this.$tc('challenge.advisers', 2, {count: advisers}).toString();
      } else {
        return this.$tc('challenge.advisers', 1, {count: advisers}).toString()
      }
    }

    async mounted() {
      try {
        if (this.challenge?.id) {
          await advisersState.fetchAll(this.challenge.id)
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
